<template>
  <div>
    <Navbar/>
    <h4>Anatomía</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idAnatomia" class="form-label">IdAnatomia</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAnatomia" name="idAnatomia" v-model="datoAnatomia.idAnatomia" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoAnatomia.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="descripcion" name="descripcion" v-model="datoAnatomia.descripcion" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoAnatomia.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarAnatomia" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAnatomia" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdAnatOpcion</th>
          <th scope="col">IdAnatomia</th>
          <th scope="col">Nombre</th>
          <th scope="col">Tipo</th>
          <th scope="col">Estado</th>
          <th scope="col">AnatomiaNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="anatopcion in datosPaginados" :key="anatopcion.idAnatOpcion">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(anatopcion.idAnatOpcion)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(anatopcion.idAnatOpcion)" title="Editar">edit_square</i></td>
          <td>{{anatopcion.idAnatOpcion}}</td>
          <td>{{anatopcion.idAnatomia}}</td>
          <td>{{anatopcion.nombre}}</td>
          <td>{{anatopcion.tipo}}</td>
          <td>{{anatopcion.estado}}</td>
          <td>{{anatopcion.anatomiaNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteAnatomia(anatopcion.idAnatOpcion)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idAnatOpcion" class="form-label">IdAnatOpcion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAnatOpcion" name="idAnatOpcion" v-model="datoAnatOpcion.idAnatOpcion" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idAnatomia" class="form-label">IdAnatomia</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAnatomia" name="idAnatomia" v-model="datoAnatOpcion.idAnatomia" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoAnatOpcion.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoAnatOpcion.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarAnatOpcion" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAnatOpcion" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      anatomias : [],
      datoAnatomia : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idAnatomia: '',
// Variables master
// Variables details
      anatopcions : [],
      datoAnatOpcion : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      // anatomias : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idAnatomia = this.$route.params.p_idanatomia
    this.abrirEditar(this.p_idAnatomia)
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'nombre'
        ,'descripcion'
        ,'tipo'
      ];
      const requiredFieldsText = [
        'nombre'
        ,'descripcion'
        ,'tipo'
      ];
      return validarForm(this.datoAnatomia, requiredFields, requiredFieldsText);
    },
    async guardarAnatomia(){
      if(this.validarForm() === 1){
        try {
          await api.post('/anatomias', this.datoAnatomia)
          swal("Correcto!", "Anatomia creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAnatomia(){
      if(this.validarForm() === 1){
        try {
          await api.post('/anatomias', this.datoAnatomia)
          swal("Correcto!", "Anatomia creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoAnatomia={}
      this.titulo   = 'Crear Anatomía'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idAnatomia){
      this.modalWindow = true
      if(idAnatomia != null){    
           api.get('/vwanatomias/'+idAnatomia).then(resp=>{
          this.datoAnatomia = resp.data;
           });
      }
      this.titulo   = 'Editar Anatomía'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarAnatomia(){
      this.$router.push('/Anatomia')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.anatopcions.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwanatopcions/nombre/'+this.nombreBusqueda).then(response=>{
          this.anatopcions=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.anatopcions.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwanatopcions').then(response=>{
      this.anatopcions=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.anatopcions.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'nombre'
        ,'descripcion'
        ,'tipo'
      ];
      const requiredFieldsText = [
        'nombre'
        ,'descripcion'
        ,'tipo'
      ];
      return validarForm(this.datoAnatomia, requiredFields, requiredFieldsText);
    },
    async guardarAnatOpcion(){
      if(this.validarForm() === 1){
        try {
          this.datoAnatOpcion.idAnatomia = this.datoAnatomia.idAnatomia;
          await api.post('/anatopcions', this.datoAnatOpcion)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "AnatOpcion creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAnatOpcion(){
      if(this.validarForm() === 1){
        try {
          await api.post('/anatopcions', this.datoAnatOpcion)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "AnatOpcion creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoAnatOpcion={}
      this.titulo   = 'Crear Anatomía'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idAnatOpcion){
      this.modalWindow = true
      if(idAnatOpcion != null){    
           api.get('/vwanatopcions/'+idAnatOpcion).then(resp=>{
          this.datoAnatOpcion = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Anatomía'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idAnatOpcion){
      this.modalWindow = true
      if(idAnatOpcion != null){
        this.$router.push('/anatopcionmd/'+idAnatOpcion)
      }
    },
    async deleteAnatOpcion (idAnatOpcion) {
      try{
        await api.delete('/anatopcions/'+idAnatOpcion)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
/*     fetchAnatomias() {
      fetch('http://localhost:8080/api/v1/anatomias')
        .then(response => response.json())
        .then(data => {
          this.anatomias = data;
        })
        .catch(error => {
          console.error('Error fetching anatomias:', error);
        });
    }, */
  },
}
</script>
